'use es6';

import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import API from './API';
var desktopUrl = 'websitegrader/v2/preview/desktop/';
var mobileUrl = 'websitegrader/v2/preview/mobile/';
var timeout = 30000;
var DESKTOP_SCREENSHOT_WIDTH = 1500;
var DESKTOP_SCREENSHOT_HEIGHT = 800;
var MOBILE_SCREENSHOT_WIDTH = 375;
var MOBILE_SCREENSHOT_HEIGHT = 667;

var _default = /*#__PURE__*/function (_API) {
  _inherits(_default, _API);

  function _default() {
    _classCallCheck(this, _default);

    return _possibleConstructorReturn(this, _getPrototypeOf(_default).apply(this, arguments));
  }

  _createClass(_default, [{
    key: "getDesktopPreview",
    value: function getDesktopPreview(websiteUrl) {
      return this.makeGetRequest(desktopUrl + websiteUrl, {
        timeout: timeout,
        query: {
          width: DESKTOP_SCREENSHOT_WIDTH,
          height: DESKTOP_SCREENSHOT_HEIGHT
        }
      });
    }
  }, {
    key: "getMobilePreview",
    value: function getMobilePreview(websiteUrl) {
      return this.makeGetRequest(mobileUrl + websiteUrl, {
        timeout: timeout,
        query: {
          width: MOBILE_SCREENSHOT_WIDTH,
          height: MOBILE_SCREENSHOT_HEIGHT
        }
      });
    }
  }]);

  return _default;
}(API);

export { _default as default };